import { store } from "../store";

export default function isLoggedIn() {
  const { clientToken } = store.getState().auth;
  if (clientToken) return true;
  else return false;
}
